import classes from './Room.module.css';
import logo from "../../../store/Fairmont_logo.png"
import {Fragment, useEffect, useState} from "react";
import defScreen from "../../../store/Fairmont_logo.png"
import axios from "axios";
import { path, assetsBaseUrl } from "../../../routes";

/* ── Weather icon SVGs – exact kiosk palette ── */
const WX_ICON = (code) => {
    const c = Number(code);
    const sz = { width: '100%', height: '100%' };
    const G = '#C4A35A';
    const M = '#8A7A6A';
    const R = '#9A8070';
    if (c === 0) return (
        <svg viewBox="0 0 48 48" fill="none" strokeLinecap="round" strokeLinejoin="round" style={sz}>
            <circle cx="24" cy="24" r="8" fill={G} fillOpacity=".2" stroke={G} strokeWidth="2.5"/>
            <line x1="24" y1="4" x2="24" y2="10" stroke={G} strokeWidth="2.5"/>
            <line x1="24" y1="38" x2="24" y2="44" stroke={G} strokeWidth="2.5"/>
            <line x1="4" y1="24" x2="10" y2="24" stroke={G} strokeWidth="2.5"/>
            <line x1="38" y1="24" x2="44" y2="24" stroke={G} strokeWidth="2.5"/>
            <line x1="9.4" y1="9.4" x2="13.7" y2="13.7" stroke={G} strokeWidth="2.5"/>
            <line x1="34.3" y1="34.3" x2="38.6" y2="38.6" stroke={G} strokeWidth="2.5"/>
            <line x1="38.6" y1="9.4" x2="34.3" y2="13.7" stroke={G} strokeWidth="2.5"/>
            <line x1="13.7" y1="34.3" x2="9.4" y2="38.6" stroke={G} strokeWidth="2.5"/>
        </svg>
    );
    if (c <= 2) return (
        <svg viewBox="0 0 48 48" fill="none" style={sz}>
            <circle cx="17" cy="22" r="7" fill={G} fillOpacity=".2" stroke={G} strokeWidth="2"/>
            <line x1="17" y1="9" x2="17" y2="12" stroke={G} strokeWidth="2" strokeLinecap="round"/>
            <line x1="17" y1="32" x2="17" y2="35" stroke={G} strokeWidth="2" strokeLinecap="round"/>
            <line x1="4" y1="22" x2="7" y2="22" stroke={G} strokeWidth="2" strokeLinecap="round"/>
            <line x1="27" y1="22" x2="30" y2="22" stroke={G} strokeWidth="2" strokeLinecap="round"/>
            <line x1="8.6" y1="13.6" x2="10.8" y2="15.8" stroke={G} strokeWidth="2" strokeLinecap="round"/>
            <line x1="23.2" y1="28.2" x2="25.4" y2="30.4" stroke={G} strokeWidth="2" strokeLinecap="round"/>
            <line x1="25.4" y1="13.6" x2="23.2" y2="15.8" stroke={G} strokeWidth="2" strokeLinecap="round"/>
            <path d="M31 38H18a8 8 0 1 1 1.1-15.9A10 10 0 0 1 38 29a7 7 0 0 1-7 9z" stroke={M} strokeWidth="2.2" strokeLinecap="round" fill={M} fillOpacity=".15"/>
        </svg>
    );
    if (c === 3) return (
        <svg viewBox="0 0 48 48" fill="none" style={sz}>
            <path d="M36 33H15a10 10 0 1 1 1.4-19.9A12 12 0 0 1 39 23a9 9 0 0 1-3 10z" stroke={M} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill={M} fillOpacity=".12"/>
        </svg>
    );
    if (c <= 48) return (
        <svg viewBox="0 0 48 48" fill="none" style={sz}>
            <line x1="8" y1="20" x2="40" y2="20" stroke={M} strokeWidth="2.5" strokeLinecap="round"/>
            <line x1="12" y1="27" x2="36" y2="27" stroke={M} strokeWidth="2.5" strokeLinecap="round"/>
            <line x1="16" y1="34" x2="32" y2="34" stroke={M} strokeWidth="2.5" strokeLinecap="round"/>
        </svg>
    );
    if (c <= 55) return (
        <svg viewBox="0 0 48 48" fill="none" style={sz}>
            <path d="M34 28H15a9 9 0 1 1 1.2-17.9A11 11 0 0 1 37 20a8 8 0 0 1-3 8z" stroke={M} strokeWidth="2.3" strokeLinecap="round" fill={M} fillOpacity=".15"/>
            <line x1="22" y1="35" x2="20" y2="42" stroke={R} strokeWidth="2.2" strokeLinecap="round"/>
            <line x1="30" y1="35" x2="28" y2="42" stroke={R} strokeWidth="2.2" strokeLinecap="round"/>
        </svg>
    );
    if (c <= 65 || c <= 82) return (
        <svg viewBox="0 0 48 48" fill="none" style={sz}>
            <path d="M34 28H15a9 9 0 1 1 1.2-17.9A11 11 0 0 1 37 20a8 8 0 0 1-3 8z" stroke={M} strokeWidth="2.3" strokeLinecap="round" fill={M} fillOpacity=".15"/>
            <line x1="18" y1="35" x2="16" y2="42" stroke={R} strokeWidth="2.2" strokeLinecap="round"/>
            <line x1="26" y1="35" x2="24" y2="42" stroke={R} strokeWidth="2.2" strokeLinecap="round"/>
            <line x1="34" y1="35" x2="32" y2="42" stroke={R} strokeWidth="2.2" strokeLinecap="round"/>
        </svg>
    );
    if (c <= 75) return (
        <svg viewBox="0 0 48 48" fill="none" style={sz}>
            <path d="M34 28H15a9 9 0 1 1 1.2-17.9A11 11 0 0 1 37 20a8 8 0 0 1-3 8z" stroke={M} strokeWidth="2.3" strokeLinecap="round" fill={M} fillOpacity=".15"/>
            <circle cx="18" cy="37" r="2" fill={G}/>
            <circle cx="26" cy="41" r="2" fill={G}/>
            <circle cx="34" cy="37" r="2" fill={G}/>
        </svg>
    );
    return (
        <svg viewBox="0 0 48 48" fill="none" style={sz}>
            <path d="M34 26H15a9 9 0 1 1 1.2-17.9A11 11 0 0 1 37 18a8 8 0 0 1-3 8z" stroke={M} strokeWidth="2.3" strokeLinecap="round" fill={M} fillOpacity=".15"/>
            <line x1="18" y1="33" x2="16" y2="40" stroke={R} strokeWidth="2" strokeLinecap="round"/>
            <line x1="34" y1="33" x2="32" y2="40" stroke={R} strokeWidth="2" strokeLinecap="round"/>
            <polyline points="28,30 24,38 27,38 23,46" stroke={G} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </svg>
    );
};
const WX_DESC = {0:'Clear sky',1:'Mainly clear',2:'Partly cloudy',3:'Overcast',45:'Foggy',48:'Icy fog',51:'Light drizzle',53:'Drizzle',55:'Heavy drizzle',61:'Light rain',63:'Rain',65:'Heavy rain',71:'Light snow',73:'Snow',75:'Heavy snow',80:'Showers',81:'Rain showers',82:'Heavy showers',95:'Thunderstorm',99:'Thunderstorm'};

/** Radisson Blu – když na displeji neběží meeting, zobrazit tuto fotku */
const RADISSON_BLU_ORG_ID = 'AC9D7FD5-E333-4B1E-9043-4697568313B7';
const RADISSON_BLU_NO_MEETING_IMAGE = 'uploads/thumbnail_image004.bfa3ed51f067a583ce0a.png';
const FAIRMONT_GOLDEN_PRAGUE_ORG_ID = '7A67452A-F5D4-430D-B283-8A93B28B425C';
const HOLIDAY_INN_ORG_ID = 'E15F8010-B7EB-4526-A985-F00D517EBF4C';

const RoomFairmont = (props) => {
    const [actTime, setactTime] = useState("undefined");
    const [actDate, setactDate] = useState("undefined");
    const [roomName, setroomName] = useState(props.roomName);
    const [logoOrg, setLogoOrg] = useState(props.logoOrg);
    const [roomtext, setroomText] = useState(props.text);
    const [subtitle, setSubtitle] = useState('');
    const [posterImg, setPosterImg] = useState(null);
    const [roomID, setroomID] = useState(props.roomId);
    const [meeting_ob, setMeeting_ob] = useState(false);
    const [logoHeader , setLogoHeader] = useState();
    const [isRunning, setIsRunning] = useState(false);
    const [meetingData, setMeetingData] = useState(null);
    const [backgroundColor, setBackgroundColor] = useState('#012e5f');
    const [roomNameColor, setRoomNameColor] = useState('#ffffff');
    const [meetingTitleColor, setMeetingTitleColor] = useState('#000000');
    const [showLogo, setShowLogo] = useState(true);
    const [showTitle, setShowTitle] = useState(true);
    const [showTimeRange, setShowTimeRange] = useState(false);
    const [slideshowPriority, setSlideshowPriority] = useState(false);
    const [deviceRoomGroup, setDeviceRoomGroup] = useState(null);
    const [slideshowCards, setSlideshowCards] = useState([]);
    const [slideshowIndex, setSlideshowIndex] = useState(0);
    const [slideIntervalSec, setSlideIntervalSec] = useState(15);
    const [objectFitSlideshow, setObjectFitSlideshow] = useState('contain');
    const [deviceDescription, setDeviceDescription] = useState(null);
    const [deviceOrgId, setDeviceOrgId] = useState(null); // org z backendu – pro načtení slideshow i bez org v URL
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [wxTemp, setWxTemp] = useState(null);
    const [wxDesc, setWxDesc] = useState('Prague');
    const [wxCode, setWxCode] = useState(null);
    const [wxForecast, setWxForecast] = useState([]); // 4denní předpověď (jako na kiosku)
    // const actTime = `${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`;
    //const actDate = `${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`;
    const getTime = () => {
        const now = new Date();

        // Získání jednotlivých částí data
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexovány od 0
        const day = String(now.getDate()).padStart(2, '0');

        // Získání jednotlivých částí času
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        // Sestavení výsledného řetězce
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }
    useEffect(() => {
        let cancelled = false;
        let retryTimer = null;
        const fetchWx = async () => {
            try {
                const r = await fetch('https://api.open-meteo.com/v1/forecast?latitude=50.0755&longitude=14.4378&current=temperature_2m,weathercode&daily=weathercode,temperature_2m_max,temperature_2m_min&timezone=Europe/Prague&forecast_days=5');
                if (!r.ok) throw new Error('weather HTTP ' + r.status);
                const j = await r.json();
                if (cancelled) return;
                if (!j || !j.current || typeof j.current.temperature_2m !== 'number') {
                    throw new Error('weather: nečekaná odpověď');
                }
                setWxTemp(Math.round(j.current.temperature_2m));
                setWxCode(j.current.weathercode);
                setWxDesc((WX_DESC[j.current.weathercode] || '') + ' · Prague');
                const fc = [];
                if (j.daily && Array.isArray(j.daily.time)) {
                    for (let i = 1; i <= 4 && i < j.daily.time.length; i++) {
                        const dd = new Date(j.daily.time[i]);
                        fc.push({
                            d: dd.getDate() + '.' + (dd.getMonth() + 1) + '.',
                            code: j.daily.weathercode[i],
                            max: Math.round(j.daily.temperature_2m_max[i]),
                            min: Math.round(j.daily.temperature_2m_min[i]),
                        });
                    }
                }
                setWxForecast(fc);
            } catch (e) {
                // Místo tichého spolknutí: zaloguj a zkus znovu brzy (ne až za 30 min),
                // aby přechodný výpadek sítě/API neznamenal 30 minut „--°".
                console.warn('[RoomFairmont] Weather fetch failed, retry za 15 s:', e);
                if (!cancelled) {
                    if (retryTimer) clearTimeout(retryTimer);
                    retryTimer = setTimeout(fetchWx, 15 * 1000);
                }
            }
        };
        fetchWx();
        const id = setInterval(fetchWx, 30 * 60 * 1000);
        return () => {
            cancelled = true;
            if (retryTimer) clearTimeout(retryTimer);
            clearInterval(id);
        };
    }, []);

    const getOrg = async (org) => {
        const o = org ?? props.org;
        if (!o) return;
        try {
            const response = await axios.get(`${path}/getOrganization/${o}`);
            if (response.data && response.data.length > 0) {
                setLogoHeader(assetsBaseUrl + response.data[0].logoPath);
            }
        } catch (error) {
            // ignore
        }
    };
    useEffect(() => {
        const deviceId = roomID;
        const orgId = props.org || deviceOrgId;
        if (deviceId) {
            let url = orgId ? `${path}/getDeviceSettings/${deviceId}?orgID=${encodeURIComponent(orgId)}` : `${path}/getDeviceSettings/${deviceId}`;
            if (refreshTrigger > 0) url += (url.includes('?') ? '&' : '?') + `_t=${refreshTrigger}`; // cache-bust po změně
            axios.get(url)
                .then((r) => {
                    const s = r.data?.settings || {};
                    if (s.backgroundColor) setBackgroundColor(s.backgroundColor);
                    else setBackgroundColor('#012e5f');
                    if (s.roomNameColor) setRoomNameColor(s.roomNameColor);
                    else if (s.textColor) setRoomNameColor(s.textColor);
                    else setRoomNameColor('#ffffff');
                    if (s.meetingTitleColor) setMeetingTitleColor(s.meetingTitleColor);
                    else if (s.textColor) setMeetingTitleColor(s.textColor);
                    else setMeetingTitleColor('#000000');
                    if (typeof s.showLogo === 'boolean') setShowLogo(s.showLogo);
                    if (typeof s.showTitle === 'boolean') setShowTitle(s.showTitle);
                    if (typeof s.showTimeRange === 'boolean') setShowTimeRange(s.showTimeRange);
                    else setShowTimeRange(false);
                    if (typeof s.slideshowPriority === 'boolean') setSlideshowPriority(s.slideshowPriority);
                    else setSlideshowPriority(false);
                    if (typeof s.slideIntervalSec === 'number') setSlideIntervalSec(Math.max(3, Math.min(300, s.slideIntervalSec)));
                    if (s.objectFit === 'cover' || s.objectFit === 'contain') setObjectFitSlideshow(s.objectFit);
                    const rg = r.data?.deviceRoomGroup;
                    const parsed = (rg != null && rg !== undefined && Number.isFinite(Number(rg)) && Number(rg) >= 0) ? Math.floor(Number(rg)) : null;
                    setDeviceRoomGroup(parsed);
                    const name = r.data?.deviceDescription;
                    setDeviceDescription(name != null && String(name).trim() ? String(name).trim() : null);
                    if (r.data?.deviceOrgId) setDeviceOrgId(r.data.deviceOrgId);
                })
                .catch(() => {});
        }
    }, [roomID, props.org, refreshTrigger]);

    const effectiveOrg = props.org || deviceOrgId;

    // Načíst karty slideshow pro skupinu displeje; při odebrání ze skupiny (gr null) vymazat fotky
    useEffect(() => {
        const gr = deviceRoomGroup;
        if (gr == null || gr === undefined || Number(gr) <= 0 || !effectiveOrg) {
            setSlideshowCards([]);
            setSlideshowIndex(0);
            return;
        }
        let cancelled = false;
        const cardsUrl = `${path}/getCardsV3?orgID=${effectiveOrg}&group=${gr}&onlyVisible=1&device_group=1${refreshTrigger > 0 ? `&_t=${refreshTrigger}` : ''}`;
        axios.get(cardsUrl)
            .then((res) => {
                if (cancelled) return;
                const raw = Array.isArray(res.data) ? res.data : [];
                const urls = raw.filter(c => c && c.path).map(c => assetsBaseUrl + c.path);
                setSlideshowCards(urls);
                setSlideshowIndex(0);
            })
            .catch(() => {
                if (!cancelled) setSlideshowCards([]);
            });
        return () => { cancelled = true; };
    }, [deviceRoomGroup, effectiveOrg, refreshTrigger]);

    // Posun slideshow při „no meeting"
    useEffect(() => {
        if (slideshowCards.length <= 1) return;
        const intervalMs = Math.max(3000, (slideIntervalSec || 15) * 1000);
        const id = setInterval(() => {
            setSlideshowIndex((prev) => (prev + 1) % slideshowCards.length);
        }, intervalMs);
        return () => clearInterval(id);
    }, [slideshowCards.length, slideIntervalSec]);

    useEffect(() => {
        getOrg(effectiveOrg);
        // Funkce, která se spustí každou minutu

        const hourDelay =60 *  15 * 1000; // 1 hour in milliseconds
       // const refreshPage = setTimeout(() => {
       //     window.location.reload();
        //}, hourDelay);

        const resetVal = async (org) => {
            try {
                await axios.post(`${path}/updateReset/${roomID}`, org ? { orgID: org } : {});
            } catch (_) {}
        };
        const getReset = async () => {
            try {
                const orgParam = effectiveOrg ? `?orgID=${encodeURIComponent(effectiveOrg)}` : '';
                const response = await axios.get(`${path}/getReset/${roomID}${orgParam}`);
                const need = response.data?.[0]?.needUpdate;
                if (need === 1 || need === true) {
                    console.log("[RoomFairmont] Změna nastavení – obnovuji data bez reloadu");
                    await resetVal(effectiveOrg);
                    setRefreshTrigger((t) => t + 1);
                }
            } catch (error) {
                // ignore
            }
        };


        const send = async () =>{
            try {
                const currentTime = getTime();
                // Use query parameter endpoint directly for production (dev.csgcontrols.cz) due to IIS routing issues
                const useQueryEndpoint = path.includes('dev.csgcontrols.cz') || path.includes('csgcontrols.cz');
                const url = useQueryEndpoint 
                    ? `${path}/getMeetingQuery?id=${roomID}&day=${encodeURIComponent(currentTime)}`
                    : `${path}/getMeeting/${roomID}/${encodeURIComponent(currentTime)}`;
                console.log('[RoomFairmont] Fetching meeting:', { roomID, currentTime, url, useQueryEndpoint });
                const response = await axios.get(url);
                const data = Array.isArray(response.data) ? response.data : [];
                console.log('[RoomFairmont] Meeting response:', { roomID, dataLength: data.length, data });
                if (data.length > 0) {
                    const rec = data[0];
                    console.log('[RoomFairmont] Found meeting:', { 
                        id: rec.id, 
                        description: rec.description, 
                        dateFrom: rec.dateFrom, 
                        dateTo: rec.dateTo,
                        path: rec.path 
                    });
                    setroomText(rec.description ?? '');
                    setSubtitle(rec.subtitle ?? '');
                    setPosterImg(rec.posterPath ? `${assetsBaseUrl}${String(rec.posterPath).replace(/\\/g,'/')}?t=${Date.now()}` : null);
                    // Cache-busting: přidat časový parametr, aby se po změně loga akce načetla nová verze obrázku
                    setLogoOrg(rec.path ? `${assetsBaseUrl}${rec.path}?t=${Date.now()}` : null);
                    setMeetingData(rec);

                    // Check if meeting is currently running
                    const now = new Date().getTime();
                    const dateFrom = new Date(rec.dateFrom).getTime();
                    const dateTo = new Date(rec.dateTo).getTime();
                    const running = dateFrom <= now && now <= dateTo;
                    setIsRunning(running);
                } else {
                    console.log('[RoomFairmont] No meeting found for roomID:', roomID, 'at time:', currentTime);
                    setLogoOrg(null);
                    setroomText(null);
                    setSubtitle('');
                    setMeetingData(null);
                    setIsRunning(false);
                }
            }
            catch (error){
                console.error('[RoomFairmont] Error fetching meeting:', error);
                console.error('[RoomFairmont] Error details:', {
                    message: error.message,
                    response: error.response?.data,
                    status: error.response?.status,
                    roomID
                });
                setLogoOrg(null);
                setPosterImg(null);
                setroomText(null);
                setSubtitle('');
                setMeetingData(null);
                setIsRunning(false);
            }
        }



        const updateMinute = () => {
            let dt = new Date();
            setactTime(`${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`);
            setactDate(`${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`);
            
            // Update running status every second
            if (meetingData) {
                const now = new Date().getTime();
                const dateFrom = new Date(meetingData.dateFrom).getTime();
                const dateTo = new Date(meetingData.dateTo).getTime();
                setIsRunning(dateFrom <= now && now <= dateTo);
            }
        };
        updateMinute();
        send();
        getReset(); // kontrola hned po načtení
        const intervalId = setInterval(updateMinute, 1000);
        const intervalId2 = setInterval(send, 5 * 1000);
        const intervalId3 = setInterval(getReset, 3 * 1000); // každé 3 s, aby změny (zmizení fotek / skupiny) přišly bez refresh
        const onVisibility = () => {
            if (typeof document !== 'undefined' && document.visibilityState === 'visible') getReset();
        };
        document.addEventListener('visibilitychange', onVisibility);

        return () => {
            clearInterval(intervalId);
            clearInterval(intervalId2);
            clearInterval(intervalId3);
            document.removeEventListener('visibilitychange', onVisibility);
        };
    }, [refreshTrigger, roomID, effectiveOrg]);

    const rawName = deviceDescription ?? roomName ?? props.roomName;
    const roomDisplayName = (rawName != null && String(rawName).trim() && String(rawName).toLowerCase() !== 'undefined')
        ? String(rawName).trim()
        : (roomID ? `Místnost ${roomID}` : '—');

    useEffect(() => {
        if (typeof document !== 'undefined' && roomDisplayName) {
            document.title = roomDisplayName;
        }
    }, [roomDisplayName]);

    const hasMeeting = roomtext != null && roomtext !== '';
    const orgUpper = (effectiveOrg || '').toString().trim().toUpperCase();
    const isRadissonBlu = orgUpper === RADISSON_BLU_ORG_ID.toUpperCase();
    const isFairmont = orgUpper === FAIRMONT_GOLDEN_PRAGUE_ORG_ID.toUpperCase();
    const isHolidayInn = orgUpper === HOLIDAY_INN_ORG_ID.toUpperCase();
    const radissonNoMeetingImageUrl = assetsBaseUrl + RADISSON_BLU_NO_MEETING_IMAGE;

    const slideshowUrl = slideshowCards.length > 0 ? slideshowCards[slideshowIndex % slideshowCards.length] : null;
    const slideshowView = slideshowUrl ? (
        <div className={classes.mainNo}>
            <img src={slideshowUrl} alt="" style={{ width: '100%', height: '100%', objectFit: objectFitSlideshow }} />
        </div>
    ) : null;
    const radissonNoMeetingView = (
        <div className={classes.mainNo}>
            <img src={radissonNoMeetingImageUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
    );
    const radissonMeetingView = (
        <div style={{
            position: 'absolute', inset: 0, background: '#ffffff',
            display: 'flex', flexDirection: 'column', overflow: 'hidden'
        }}>
            {/* Modrý header s názvem místnosti (případně spojených) */}
            <div style={{
                background: '#012e5f', color: '#ffffff',
                padding: '14px 24px', textAlign: 'center',
                fontSize: '44px', fontWeight: 700, letterSpacing: '0.06em',
                textTransform: 'uppercase', flexShrink: 0
            }}>
                {roomDisplayName}
            </div>

            {/* Tělo: název meetingu + event logo */}
            <div style={{
                flex: 1, display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'flex-start',
                padding: '24px 60px 80px 60px', minHeight: 0, gap: '20px'
            }}>
                <div style={{
                    fontSize: '52px', fontWeight: 800, color: '#000000',
                    textAlign: 'center', lineHeight: 1.15
                }}>
                    {roomtext}
                </div>
                {logoOrg && (
                    <div style={{
                        flex: 1, width: '100%', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', minHeight: 0
                    }}>
                        <img src={logoOrg} alt="logo"
                            style={{ maxWidth: '70%', maxHeight: '100%', objectFit: 'contain' }} />
                    </div>
                )}
            </div>

            {/* Malé Radisson logo v pravém dolním rohu */}
            <img
                src={`${path}/admin/org_logo//RadissonBlu-logo.png`}
                alt="Radisson Blu"
                style={{
                    position: 'absolute', bottom: '16px', right: '20px',
                    height: '32px', width: 'auto', objectFit: 'contain'
                }}
            />
        </div>
    );

    // Time label HH:mm – HH:mm (from string, no timezone conversion)
    let timeLabel = null;
    if (meetingData && meetingData.dateFrom && meetingData.dateTo) {
        try {
            const sf = String(meetingData.dateFrom).trim();
            const st = String(meetingData.dateTo).trim();
            const tf = sf.length >= 16 ? sf.substring(11, 16) : '';
            const tt = st.length >= 16 ? st.substring(11, 16) : '';
            if (tf && tt) timeLabel = tf + ' – ' + tt;
        } catch (_) {}
    }

    // Nice date helpers
    const DAYS   = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    const _now = new Date();
    const niceDate = DAYS[_now.getDay()] + ', ' + _now.getDate() + ' ' + MONTHS[_now.getMonth()] + ' ' + _now.getFullYear();
    // Hodiny v topbaru jako na kiosku: den + datum
    const clockDay = DAYS[_now.getDay()].toUpperCase();
    const clockDate = _now.getDate() + ' ' + MONTHS[_now.getMonth()].toUpperCase() + ' ' + _now.getFullYear();

    // Event name font-size class
    const nameLen = (roomtext || '').length;
    const nameCls = [classes.fmEventName, nameLen > 40 ? classes.fmEventNameVeryLong : nameLen > 22 ? classes.fmEventNameLong : ''].filter(Boolean).join(' ');

    // ── KIOSK TOPBAR (shared) ──
    const kioskTopbar = (
        <div className={classes.fmKioskTopbar}>
            <div className={classes.fmKioskLogo}>
                <img src={logo} alt="Fairmont Golden Prague" />
            </div>
            <div className={classes.fmKioskSep} />
            <div className={classes.fmKioskWeather}>
                <div className={classes.fmKioskWxNow}>
                    <div className={classes.fmKioskWxIco}>
                        {wxCode !== null ? WX_ICON(wxCode) : null}
                    </div>
                    <div className={classes.fmKioskWxTexts}>
                        <div className={classes.fmKioskWxTemp}>{wxTemp !== null ? wxTemp + '\u00b0C' : '--\u00b0'}</div>
                        <div className={classes.fmKioskWxDesc}>{wxDesc}</div>
                    </div>
                </div>
                {wxForecast.length > 0 && (
                    <div className={classes.fmKioskWxFc}>
                        {wxForecast.map((f, i) => (
                            <div className={classes.fmFcDay} key={i}>
                                <div className={classes.fmFcDate}>{f.d}</div>
                                <div className={classes.fmFcIco}>{WX_ICON(f.code)}</div>
                                <div className={classes.fmFcTemp}>{f.max}{'\u00b0'}/{f.min}{'\u00b0'}</div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <div className={classes.fmKioskSep} />
            <div className={classes.fmKioskClockWrap}>
                <div className={classes.fmKioskClockTime}>{actTime}</div>
                <div className={classes.fmKioskClockDay}>{clockDay}</div>
                <div className={classes.fmKioskClockDate}>{clockDate}</div>
            </div>
        </div>
    );

    // ── MEETING RUNNING ──
    // Logo zabírá horní ~1/3, titulek začíná ve 2. třetině, ornament hned pod ním
    const fairmontMeeting = (
        <div className={classes.fmDisp}>
            {kioskTopbar}
            <div className={classes.fmGoldLine} />

            {/* Hlavní oblast: ornament uprostřed dělí na dvě půlky.
                Horní půlka = logo akce, dolní půlka = titul + subtitul. */}
            <div className={classes.fmHalves}>
                <div className={classes.fmHalfTop}>
                    {logoOrg && <img src={logoOrg} alt="" className={classes.fmMeetingLogoImg} />}
                </div>

                <div className={classes.fmOrnament}>
                    <div className={classes.fmOrnLine} />
                    <div className={classes.fmOrnDiamond} />
                    <div className={classes.fmOrnDot} />
                    <div className={classes.fmOrnDiamond} />
                    <div className={classes.fmOrnLine + ' ' + classes.fmOrnLineR} />
                </div>

                <div className={classes.fmHalfBottom}>
                    <div className={nameCls}>{roomtext}</div>
                    {subtitle && <div className={classes.fmEventSubtitle}>{subtitle}</div>}
                </div>
            </div>

            {/* Bottom */}
            <div className={classes.fmBottom}>
                <div className={classes.fmRoomLabel}>{roomDisplayName.toUpperCase()}</div>
                <div className={classes.fmTimeRange}>{timeLabel || actTime}</div>
                <div className={classes.fmDate}>{niceDate}</div>
            </div>
        </div>
    );

    // ── NO MEETING – logo v kruhu (Fairmont fallback) ──
    const fairmontNoMeeting = (
        <div className={classes.fmDisp}>
            {kioskTopbar}
            <div className={classes.fmGoldLine} />

            <div className={classes.fmLogoArea}>
                <div className={classes.fmLogoWrap}>
                    <img src={logo} alt="Fairmont" className={classes.fmLogoImgFallback} />
                </div>
            </div>

            <div className={classes.fmBottom}>
                <div className={classes.fmRoomLabel}>{roomDisplayName.toUpperCase()}</div>
                <div className={classes.fmTimeRange}>{actTime}</div>
                <div className={classes.fmDate}>{niceDate}</div>
            </div>
        </div>
    );

    // Neutrální view pro hotely bez vlastního brandu (Holiday Inn, neznámý
    // org). Žádné Fairmont/Radisson logo, jen čistý layout s názvem místnosti
    // a textem meetingu. Pro Holiday Inn použít HI logo v pravém dolním rohu.
    const neutralMeetingView = (
        <div style={{
            position: 'absolute', inset: 0, background: '#ffffff',
            display: 'flex', flexDirection: 'column', overflow: 'hidden'
        }}>
            <div style={{
                background: '#012e5f', color: '#ffffff',
                padding: '14px 24px', textAlign: 'center',
                fontSize: '44px', fontWeight: 700, letterSpacing: '0.06em',
                textTransform: 'uppercase', flexShrink: 0
            }}>
                {roomDisplayName}
            </div>
            <div style={{
                flex: 1, display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'flex-start',
                padding: '24px 60px 80px 60px', minHeight: 0, gap: '20px'
            }}>
                <div style={{
                    fontSize: '52px', fontWeight: 800, color: '#000000',
                    textAlign: 'center', lineHeight: 1.15
                }}>
                    {roomtext}
                </div>
                {logoOrg && (
                    <div style={{
                        flex: 1, width: '100%', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', minHeight: 0
                    }}>
                        <img src={logoOrg} alt="logo"
                            style={{ maxWidth: '70%', maxHeight: '100%', objectFit: 'contain' }} />
                    </div>
                )}
            </div>
        </div>
    );
    const neutralNoMeetingView = (
        <div style={{
            position: 'absolute', inset: 0, background: '#ffffff',
            display: 'flex', flexDirection: 'column', overflow: 'hidden'
        }}>
            <div style={{
                background: '#012e5f', color: '#ffffff',
                padding: '14px 24px', textAlign: 'center',
                fontSize: '44px', fontWeight: 700, letterSpacing: '0.06em',
                textTransform: 'uppercase', flexShrink: 0
            }}>
                {roomDisplayName}
            </div>
            <div style={{
                flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '36px', color: '#666'
            }}>
                {actTime}
            </div>
        </div>
    );

    // Poster (full-screen) – když má běžící meeting nahraný poster, překryje celý displej
    const posterView = (
        <div className={classes.mainNo} style={{ background: '#000' }}>
            <img src={posterImg} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
    );

    // Routing
    if (hasMeeting && posterImg) return <>{posterView}</>;
    if (slideshowPriority && slideshowView) return <>{slideshowView}</>;
    // Radisson Blu: vlastní Radisson layout (meeting i no-meeting), nikdy Fairmont
    if (isRadissonBlu) return <>{hasMeeting ? radissonMeetingView : radissonNoMeetingView}</>;
    // Holiday Inn (a další ne-Fairmont hotely): neutrální view, ne Fairmont branding.
    // Pokud někdy přidáme HI-specific layout, sem ho zapojíme.
    if (isHolidayInn || (!isFairmont && effectiveOrg)) {
        return <>{hasMeeting ? neutralMeetingView : neutralNoMeetingView}</>;
    }
    if (!hasMeeting && slideshowView) return <>{slideshowView}</>;
    if (hasMeeting) return <>{fairmontMeeting}</>;
    return <>{fairmontNoMeeting}</>;
}
export default RoomFairmont